// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__l5LnX","content":"RecentSearches_content__3s2Dl"};